import { useState } from 'react';

const INDIVIDUAL_SCHEDULE_PDF_SRC = '/context/admin/individual-schedule/INDIVIDUAL_SCHEDULE.pdf';
const PIV_SCHEDULE_PDF_SRC = '/context/admin/individual-schedule/Personal_Investment_Vehicle.pdf';

export enum IndividualScheduleTabNames {
	INDIVIDUALS,
	PERSONAL_INVESTMENT_VEHICLES,
}

export const useIndividualScheduleController = () => {
	const [selectedTabName, setSelectedTabName] = useState(IndividualScheduleTabNames.INDIVIDUALS);
	const isActiveTab = (tabName: IndividualScheduleTabNames) => {
		return tabName === selectedTabName;
	};

	const pdfPath = isActiveTab(IndividualScheduleTabNames.INDIVIDUALS)
		? INDIVIDUAL_SCHEDULE_PDF_SRC
		: PIV_SCHEDULE_PDF_SRC;

	return { selectedTabName, setSelectedTabName, isActiveTab, pdfPath };
};
